import React from 'react';
import NotificationStackListener from './NotificationStackListener';
import { playAdminNotificationSound, STAFF_SOUND_PREF } from '../utils/notificationSounds';

export default function StaffNotificationListener() {
  return (
    <NotificationStackListener
      tokenKey="token"
      sinceKey="staff_notif_since"
      soundPrefKey={STAFF_SOUND_PREF}
      apiPath="/notifications"
      playSound={playAdminNotificationSound}
      severity="info"
      soundPromptTitle="Staff notification sounds"
      soundPromptBody="Play a short sound when new alerts arrive (e.g. member registrations)? You can dismiss this and stay silent."
    />
  );
}
